import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild,
} from '@headlessui/react';
import { Close } from '../svg';
import React, { useState, useRef } from 'react';
import clsx from 'clsx';

export interface IDialogProps {
  open: boolean;
  toggle: (open: boolean) => void;
  children?: React.ReactNode;
  hideCloseIcon?: boolean;
  hideUnderline?: boolean;
  className?: string;
  hscreen?: boolean;
}

export default function Index({
  open,
  toggle,
  children,
  hideCloseIcon = false,
  hideUnderline = false,
  className,
  hscreen = false,
}: IDialogProps) {
  const [touchStartY, setTouchStartY] = useState(0);
  const srcollRef = useRef<HTMLDivElement>(null);
  return (
    <Transition appear show={open}>
      <Dialog
        as="div"
        className="relative z-[1500] focus:outline-none bg-[rgba(247, 247, 248, 0.5)]"
        onClose={() => {
          toggle(false);
        }}
      >
        <div className="fixed inset-0 z-10 w-screen backdrop-blur-[5px] overflow-y-auto flex flex-col justify-end font-nunito_sans">
          <div className="flex items-stretch justify-center max-h-screen ">
            {/* <div className="flex min-h-full items-stretch justify-center"> */}
            <TransitionChild
              enter="transition ease-in-out duration-300 transform"
              enterFrom="translate-y-full"
              enterTo="translate-y-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-y-0"
              leaveTo="translate-y-full"
            >
              <DialogPanel className="w-full max-w-md h-auto text-primary flex flex-col">
                <div className={clsx('bg-modal rounded-t-xl ', className)}>
                  <div className={hscreen ? '' : 'relative z-10'}>
                    {hideCloseIcon ? (
                      <div
                      // onTouchStart={e => {
                      //   if (!hscreen) setTouchStartY(e.touches[0].pageY);
                      // }}
                      // onTouchMove={e => {
                      //   if (hscreen) return;
                      //   const currentY = e.touches[0].pageY;
                      //   if (currentY - touchStartY > 10) {
                      //     toggle(false);
                      //   }
                      // }}
                      // className="h-8 flex items-start justify-center pt-1"
                      >
                        {!hideUnderline && (
                          <div className="h-8 flex items-start justify-center pt-1">
                            <svg
                              className="text-secondary"
                              xmlns="http://www.w3.org/2000/svg"
                              width="32"
                              height="3"
                              viewBox="0 0 32 3"
                              fill="none"
                            >
                              <path
                                d="M2 1.5H30"
                                stroke="currentColor"
                                strokeOpacity="0.18"
                                strokeWidth="3"
                                strokeLinecap="round"
                              />
                            </svg>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="flex justify-end mt-3">
                        <div
                          className="rounded-full relative z-[9999] bg-black text-quaternary px-6 flex justify-center items-center mt-[0px] cursor-pointer"
                          onClick={() => toggle(false)}
                        >
                          <Close className="w-[20px] h-[20px]" />
                        </div>
                      </div>
                    )}
                  </div>

                  <div
                    ref={srcollRef}
                    onTouchStart={e => {
                      if (!hscreen) setTouchStartY(e.touches[0].pageY);
                    }}
                    onTouchMove={e => {
                      if (hscreen) return;
                      const currentY = e.touches[0].pageY;
                      if (currentY - touchStartY > 20) {
                        if (srcollRef.current?.scrollTop === 0) {
                          toggle(false);
                        }
                      }
                    }}
                    className={clsx(
                      'overflow-y-auto',
                      !hscreen
                        ? 'max-h-[calc(100vh-55px)] bottom-safe-area'
                        : '',
                    )}
                  >
                    {children}
                  </div>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
